// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'article-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='currentColor'
      d='M1.84 9.173a.708.708 0 0 1-.71-.709V2.208a.71.71 0 0 1 .71-.708h6.623c.392 0 .709.317.709.708v6.256a.708.708 0 0 1-.709.709z'
    />
    <path d='M1.13 12.84h15.736M11.883 1.5h4.986m-4.986 3.838h4.986m-4.986 3.835h4.986M1.13 16.674h15.736' />
  </g>
);

export const viewBox = '0 0 18 18';
